export default "__VITE_ASSET__a3cef295__"